export class CreateGroup{
    groupName:string;
}